import { useQuery } from "@tanstack/react-query";

import { type DocumentCategory, listDocuments } from "@/adapters/api";
import type { DocumentsPage } from "../types.ts";
import { toDocumentsPage } from "../utils/map.ts";

export const DOCUMENTS_PAGE_SIZE = 50;

export interface DocumentsFilters {
	category?: DocumentCategory;
	page?: number;
}

export function documentsQueryKey(constructionId: string | undefined) {
	return ["documents", constructionId] as const;
}

export function useDocuments(
	constructionId: string | undefined,
	filters: DocumentsFilters,
) {
	return useQuery({
		queryKey: [
			...documentsQueryKey(constructionId),
			filters.category ?? "",
			filters.page ?? 1,
		],
		queryFn: async (): Promise<DocumentsPage> => {
			// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
			const response = await listDocuments(constructionId!, {
				category: filters.category,
				page: filters.page ?? 1,
				pageSize: DOCUMENTS_PAGE_SIZE,
			});
			return toDocumentsPage(response);
		},
		enabled: !!constructionId,
		staleTime: 15_000,
		placeholderData: (previous) => previous,
	});
}
